var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "issues-drawer",
      attrs: {
        "overlay-opacity": "0.3",
        touchless: "",
        color: "accent",
        absolute: "",
        right: "",
        stateless:
          _vm.$vuetify.breakpoint.smAndDown ||
          _vm.isNotDesktop ||
          _vm.alertDrawerClipped,
        temporary: _vm.$vuetify.breakpoint.smAndDown,
        value: _vm.getAlertDrawerValue,
        "hide-overlay": !_vm.isNotDesktop,
      },
      scopedSlots: _vm._u([
        {
          key: "prepend",
          fn: function () {
            return [
              _vm.$vuetify.breakpoint.smAndDown || _vm.isNotDesktop
                ? _c(
                    "v-btn",
                    {
                      staticClass: "absolute",
                      staticStyle: { left: "8px", top: "8px" },
                      attrs: { icon: "", "x-small": "", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("toggle-issues-drawer", false)
                        },
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        { staticStyle: { "font-size": "19px !important" } },
                        [_vm._v("fas fa-times-circle")]
                      ),
                    ],
                    1
                  )
                : _vm.$vuetify.breakpoint.mdAndUp
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    staticClass: "absolute",
                                    staticStyle: { left: "8px", top: "8px" },
                                    attrs: {
                                      color: _vm.alertDrawerClipped
                                        ? "secondary"
                                        : "white",
                                      icon: "",
                                      "x-small": "",
                                      dark: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "toggle-alert-drawer-clipped"
                                        )
                                      },
                                    },
                                  },
                                  on
                                ),
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticStyle: {
                                        "font-size": "17px !important",
                                      },
                                    },
                                    [_vm._v("fas fa-thumbtack")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.alertDrawerClipped ? "Unpin" : "Pin")
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "text-center",
                  staticStyle: { background: "#47bd96" },
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "secondary-h1 py-1",
                      staticStyle: { "font-size": "19px" },
                    },
                    [_vm._v("alerts")]
                  ),
                ]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "absolute",
                  staticStyle: { right: "8px", top: "8px" },
                  attrs: { icon: "", "x-small": "", dark: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("create-alert")
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { staticStyle: { "font-size": "19px !important" } },
                    [_vm._v("fas fa-plus-circle")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "v-list",
        {
          key: _vm.listRenderKey,
          staticStyle: {
            height: "100%",
            "border-bottom": "1px solid gray",
            "border-top": "1px solid gray",
          },
          attrs: { dense: "" },
        },
        [
          _c(
            "div",
            {
              staticStyle: { height: "100%", "overflow-y": "auto !important" },
              attrs: { id: "active-issues" },
              on: {
                scroll: (ev) =>
                  _vm.syncScroll(
                    "active-issue-actions",
                    "active-issues",
                    _vm.alertCards.length,
                    ev,
                    "items"
                  ),
              },
            },
            [
              _c(
                "v-list-item",
                {
                  staticClass: "activeIssues-list-item showEnableSwitch px-0",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("show-all-history")
                    },
                  },
                },
                [
                  _c(
                    "v-list-item-title",
                    {
                      staticClass: "pt-2 pl-2",
                      staticStyle: { height: "30px" },
                    },
                    [_c("p", { staticClass: "ma-0 pa-0" }, [_vm._v("All")])]
                  ),
                ],
                1
              ),
              _vm._l(_vm.alertCards, function (alertCard, index) {
                return _c(
                  "v-list-item",
                  {
                    key: alertCard.alertStatistics.alertCardId,
                    staticClass: "activeIssues-list-item showEnableSwitch px-0",
                    class:
                      _vm.selectedCardId != null &&
                      _vm.selectedCardId ===
                        alertCard.alertStatistics.alertCardId
                        ? "selected-issue"
                        : "supplementary-class",
                    style:
                      index === _vm.alertCards.length - 1
                        ? "margin-bottom:-20px;"
                        : "opacity:1;",
                    on: {
                      click: () => {},
                      mouseover: function ($event) {
                        return _vm.$emit("show-active-issue-actions", index)
                      },
                      mouseout: function ($event) {
                        return _vm.$emit("hide-active-issue-actions", index)
                      },
                    },
                  },
                  [
                    _c(
                      "v-list-item-title",
                      { staticClass: "pl-2", staticStyle: { height: "30px" } },
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "mx-0",
                            attrs: { justify: "space-between" },
                          },
                          [
                            alertCard.alertStatistics.name.length > 17
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  {
                                                    staticClass:
                                                      "alert-card-switch show-name-of-alert-card",
                                                  },
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    "fas fa-caret-square-down"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(alertCard.alertStatistics.name)
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "v-row",
                              {
                                staticClass: "mx-0",
                                staticStyle: {
                                  height: "30px",
                                  "max-width": "170px",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectCard(alertCard)
                                  },
                                },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "ma-0 px-0 pb-0 pt-2 drawer-char-lim",
                                    class: {
                                      "grey--text":
                                        !alertCard.alertStatistics.enabled,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(alertCard.alertStatistics.name) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c("v-spacer"),
                              ],
                              1
                            ),
                            _c("v-switch", {
                              staticClass:
                                "always-primary-checkbox alert-card-switch mt-0 pt-3 pb-1 mr-1",
                              staticStyle: { width: "40px", height: "30px" },
                              attrs: {
                                small: "",
                                "hide-details": "",
                                color: "primary",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit(
                                    "alert-card-action",
                                    alertCard
                                  )
                                },
                              },
                              model: {
                                value: alertCard.alertStatistics.enabled,
                                callback: function ($$v) {
                                  _vm.$set(
                                    alertCard.alertStatistics,
                                    "enabled",
                                    $$v
                                  )
                                },
                                expression: "alertCard.alertStatistics.enabled",
                              },
                            }),
                            alertCard.alertStatistics.totalAlerts > 0
                              ? _c("v-badge", {
                                  staticClass: "mr-8 mt-5",
                                  attrs: {
                                    content:
                                      alertCard.alertStatistics.totalAlerts <
                                      100
                                        ? alertCard.alertStatistics.totalAlerts
                                        : "99+",
                                  },
                                })
                              : _c("div", { staticStyle: { width: "32px" } }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }